import * as React from "react";
function CloseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.625 21a.374.374 0 01-.265-.11L12 12.53l-8.36 8.36a.375.375 0 01-.53-.53L11.47 12 3.11 3.64a.375.375 0 01.53-.53L12 11.47l8.36-8.36a.373.373 0 01.53 0 .375.375 0 010 .53L12.53 12l8.36 8.36a.375.375 0 01-.265.64z"
  }));
}
const ForwardRef = React.forwardRef(CloseIcon);
export default ForwardRef;